import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasFeatureAccess } from "../../utils/featureAccess";
import FeatureLocked from "./FeatureLocked";

// Vendor Feature Lock (ADO #1597) — route-level guard, used inside PrivateRoute so
// Layout is already mounted. Renders the real routes only when entitled.
const FeatureGuard = ({ feature }) => {
  const login = useSelector((state) => state.loginReducer);
  return hasFeatureAccess(login, feature) ? (
    <Outlet />
  ) : (
    <FeatureLocked feature={feature} />
  );
};

export default FeatureGuard;
